var _g, _path, _g2, _g3, _g4, _g5, _g6, _g7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPrevious(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "previous",
    xmlns: "http://www.w3.org/2000/svg",
    width: 57.176,
    height: 57.176,
    viewBox: "0 0 57.176 57.176",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10535",
    "data-name": "Group 10535"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10530",
    "data-name": "Group 10530",
    transform: "translate(41.133 8.934)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12569",
    "data-name": "Path 12569",
    d: "M382.708,90.05H370.317a1.675,1.675,0,0,1-1.667-1.508l-.3-3a1.675,1.675,0,0,1,.169-.918,8.375,8.375,0,0,1,15.865,3.748A1.675,1.675,0,0,1,382.708,90.05Z",
    transform: "translate(-368.341 -80)",
    fill: "#9ee2f8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10531",
    "data-name": "Group 10531",
    transform: "translate(48.801 8.934)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12570",
    "data-name": "Path 12570",
    d: "M437,80V90.05h6.7a1.675,1.675,0,0,0,1.675-1.675A8.385,8.385,0,0,0,437,80Z",
    transform: "translate(-437 -80)",
    fill: "#8bb9ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10532",
    "data-name": "Group 10532",
    transform: "translate(0 8.934)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12571",
    "data-name": "Path 12571",
    d: "M14.071,90.05H1.675A1.675,1.675,0,0,1,0,88.375a8.375,8.375,0,0,1,15.873-3.733,1.675,1.675,0,0,1,.167.917l-.3,2.985A1.675,1.675,0,0,1,14.071,90.05Z",
    transform: "translate(0 -80)",
    fill: "#ffae43"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10533",
    "data-name": "Group 10533",
    transform: "translate(8.375 8.934)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12572",
    "data-name": "Path 12572",
    d: "M82.5,84.643A8.333,8.333,0,0,0,75,80V90.05h5.7a1.675,1.675,0,0,0,1.667-1.506l.3-2.985A1.676,1.676,0,0,0,82.5,84.643Z",
    transform: "translate(-75 -80)",
    fill: "#ff9100"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_12573",
    "data-name": "Path 12573",
    d: "M43.934,6.7V4.467a4.467,4.467,0,0,0-8.934,0V6.7a4.467,4.467,0,0,0,8.934,0Z",
    transform: "translate(-31.091)",
    fill: "#ffddce"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10534",
    "data-name": "Group 10534",
    transform: "translate(8.375)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12574",
    "data-name": "Path 12574",
    d: "M75,0V11.167A4.467,4.467,0,0,0,79.467,6.7V4.467A4.467,4.467,0,0,0,75,0Z",
    transform: "translate(-75)",
    fill: "#ffcbbc"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_12575",
    "data-name": "Path 12575",
    d: "M405.934,6.7V4.467a4.467,4.467,0,1,0-8.934,0V6.7a4.467,4.467,0,1,0,8.934,0Z",
    transform: "translate(-352.666)",
    fill: "#ffddce"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10536",
    "data-name": "Group 10536",
    transform: "translate(48.801)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12576",
    "data-name": "Path 12576",
    d: "M437,0V11.167A4.467,4.467,0,0,0,441.467,6.7V4.467A4.467,4.467,0,0,0,437,0Z",
    transform: "translate(-437)",
    fill: "#ffcbbc"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10537",
    "data-name": "Group 10537",
    transform: "translate(12.33 1.104)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12577",
    "data-name": "Path 12577",
    d: "M309.014,260.784l-3.35-5.8a1.675,1.675,0,0,1,2.9-1.675l3.35,5.8a1.675,1.675,0,1,1-2.9,1.675Z",
    transform: "translate(-283.66 -225.379)",
    fill: "#05303d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12578",
    "data-name": "Path 12578",
    d: "M306.277,254.481a1.675,1.675,0,0,0-.613,2.288l3.35,5.8a1.675,1.675,0,0,0,2.288.613Z",
    transform: "translate(-283.66 -227.167)",
    fill: "#0a617d"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_365",
    "data-name": "Ellipse 365",
    cx: 16.192,
    cy: 16.192,
    r: 16.192,
    transform: "translate(0.003)",
    fill: "#0a617d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12579",
    "data-name": "Path 12579",
    d: "M118.515,29.314A16.192,16.192,0,0,0,134.708,57.36Z",
    transform: "translate(-110.416 -27.145)",
    fill: "#0a789b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12580",
    "data-name": "Path 12580",
    d: "M332.49,323.29l-8.375-14.507a4.467,4.467,0,1,1,7.737-4.467l8.375,14.507a4.467,4.467,0,1,1-7.737,4.467Z",
    transform: "translate(-299.718 -269.452)",
    fill: "#6a75b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12581",
    "data-name": "Path 12581",
    d: "M325.749,307.448a4.467,4.467,0,0,0-1.635,6.1l8.375,14.507a4.467,4.467,0,0,0,6.1,1.635Z",
    transform: "translate(-299.718 -274.219)",
    fill: "#989fd7"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_366",
    "data-name": "Ellipse 366",
    cx: 12.842,
    cy: 12.842,
    r: 12.842,
    transform: "translate(3.353 3.35)",
    fill: "#e2dff4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12582",
    "data-name": "Path 12582",
    d: "M146.883,55.295a12.842,12.842,0,0,0,12.842,22.243Z",
    transform: "translate(-137.109 -50.224)",
    fill: "#fff5f5"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10538",
    "data-name": "Group 10538",
    transform: "translate(20.15 15.583)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12583",
    "data-name": "Path 12583",
    d: "M195.517,149.6h-13.4a1.675,1.675,0,0,1-1.675-1.675,8.375,8.375,0,0,1,16.751,0A1.675,1.675,0,0,1,195.517,149.6Z",
    transform: "translate(-180.441 -139.547)",
    fill: "#989fd7"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10539",
    "data-name": "Group 10539",
    transform: "translate(28.526 15.583)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12584",
    "data-name": "Path 12584",
    d: "M255.441,139.547V149.6h6.7a1.675,1.675,0,0,0,1.675-1.675A8.385,8.385,0,0,0,255.441,139.547Z",
    transform: "translate(-255.441 -139.547)",
    fill: "#6a75b9"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10540",
    "data-name": "Group 10540",
    transform: "translate(24.059 6.65)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12585",
    "data-name": "Path 12585",
    d: "M219.908,70.714a4.467,4.467,0,0,1-4.467-4.467V64.014a4.467,4.467,0,1,1,8.934,0v2.233A4.467,4.467,0,0,1,219.908,70.714Z",
    transform: "translate(-215.441 -59.547)",
    fill: "#ffddce"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10541",
    "data-name": "Group 10541",
    transform: "translate(28.526 6.65)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12586",
    "data-name": "Path 12586",
    d: "M255.441,59.547V70.714a4.467,4.467,0,0,0,4.467-4.467V64.014A4.467,4.467,0,0,0,255.441,59.547Z",
    transform: "translate(-255.441 -59.547)",
    fill: "#ffcbbc"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrevious);
export default __webpack_public_path__ + "static/media/previous.ae236c587b821433fb3fc6141c5ca3d3.svg";
export { ForwardRef as ReactComponent };